import React from 'react';
import '../template-file-css/document-file-template.css';


export const RRTS_AuthRequestAmerihealthChildOTRForm = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RRTS_AuthRequestAmerihealthChildOTRForm' className='file-pdf-document'>
            <div className='file-template'>


                <input type="hidden" id="hdcareq" name="careq" value="true" />
                <p>
                    Please print clearly — incomplete or illegible forms will delay processing. Please return to the AmeriHealth Caritas Louisiana Behavioral Health Utilization Management at 1-855-301-5356. For assistance contact 1-855-285-7466.
                </p>
                <h3>Member information</h3>

                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Patient name:</span></td>
                        <td className='w-375'><span className='eleHeader'>Date of birth:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtPatientName" name="txtPatientName" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="date" id="txtDateBirth" name="txtDateBirth" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Legal guardian:</span></td>
                        <td className='w-375'><span className='eleHeader'>Medicaid/health plan ID number:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtLegalGuardian" name="txtLegalGuardian" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtIdNumber" name="txtIdNumber" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Last authorization number (if applicable):</span></td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtLastAuthorizationNumber" name="txtLastAuthorizationNumber" className='add-only' />
                        </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Is the member currently in coordinated system of care (CSoC)?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rbCsoc_Yes" name="rbCsoc_Yes" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbCsoc_No" name="rbCsoc_No" className='add-only' value="No" /> No &nbsp;
                        </td>
                    </tr>
                </table>

                <h3>Provider information</h3>
                <p>
                    <span className='eleHeader'>Provider name:</span>
                    <input type="text" id="txtProviderName" name="txtProviderName" className='add-only' />
                </p>
                <p>
                    <input type="checkbox" id="cbProvider_InNetwork" name="cbProvider_InNetwork" className='add-only' value="Yes" />In network
                    <input type="checkbox" id="cbProvider_OutNetwork" name="cbProvider_OutNetwork" className='add-only' value="Yes" />Out of network
                    <input type="checkbox" id="cbProvider_Credentialing" name="cbProvider_Credentialing" className='add-only' value="Yes" />In credentialing process

                </p>
                <p>
                    <span className='eleHeader'>Group/agency name:</span>
                    <input type="text" id="txtGroupAgaency" name="txtGroupAgaency" className='add-only' />
                </p>
                <p>
                    <strong>Provider credential:</strong>

                    <input type="checkbox" id="cbProviderCredential_1" name="cbProviderCredential_1" className='add-only' value="Yes" />MD
                    <input type="checkbox" id="cbProviderCredential_2" name="cbProviderCredential_2" className='add-only' value="Yes" />PhD
                    <input type="checkbox" id="cbProviderCredential_3" name="cbProviderCredential_3" className='add-only' value="Yes" />LMHP
                    <input type="checkbox" id="cbProviderCredential_4" name="cbProviderCredential_4" className='add-only' value="Yes" />LAC
                    <input type="checkbox" id="cbProviderCredential_5" name="cbProviderCredential_5" className='add-only' value="Yes" />NP
                </p>
                <p>

                    <input type="checkbox" id="cbProviderCredential_6" name="cbProviderCredential_6" className='add-only' value="Yes" />Other:
                    <input type="text" id="txtProviderCredential_6" name="txtProviderCredential_6" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Physical address:</span>
                    <textarea id="txtPhysicalAddress" name="txtPhysicalAddress" className='add-only'> </textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Phone:</span></td>
                        <td className='w-375'><span className='eleHeader'>Fax:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtProviderPhone" name="txtProviderPhone" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtProviderFax" name="txtProviderFax" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Medicaid/provider/National Provider Identifier (NPI) number:</span></td>
                        <td className='w-375'><span className='eleHeader'>Contact name:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtProviderMedicaid" name="txtProviderMedicaid" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtProviderContactName" name="txtProviderContactName" className='add-only' />
                        </td>
                    </tr>
                </table>

                <h3>DSM diagnosis</h3>
                <p>
                    <span className='eleHeader'>Primary diagnosis:</span>
                    <input type="text" id="txtPrimaryDiagnosis" name="txtPrimaryDiagnosis" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Secondary diagnosis:</span>
                    <input type="text" id="txtSecondaryDiagnosis" name="txtSecondaryDiagnosis" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Medical diagnosis:</span>
                    <input type="text" id="txtMedicalDiagnosis" name="txtMedicalDiagnosis" className='add-only' />
                </p>
                <p>
                    Please also include the ICD-10 diagnosis code along with DSM code.
                </p>
                <p>
                    <span className='eleHeader'>If the member has a substance use and/or HIV diagnosis, has a consent to release information for these related conditions been obtained?</span>
                    <input type="radio" id="rbHivDiagnosis_Yes" name="rbHivDiagnosis" className='add-only' value="Yes" /> Yes &nbsp;
                    <input type="radio" id="rbHivDiagnosis_No" name="rbHivDiagnosis" className='add-only' value="No" /> No &nbsp;
                    <input type="radio" id="rbHivDiagnosis_Na" name="rbHivDiagnosis" className='add-only' value="Na" />N/A
                </p>

                <h3>Primary care physician (PCP) information and collaboration</h3>
                <p>
                    Has information been shared with the PCP or other providers regarding:
                </p>
                <p>
                    <span className='eleHeader'>The initial evaluation and treatment plan?</span>
                    <input type="radio" id="rbInitialTreatmentPlan_Yes" name="rbInitialTreatmentPlan" className='add-only' value="Yes" /> Yes &nbsp;
                    <input type="radio" id="rbInitialTreatmentPlan_No" name="rbInitialTreatmentPlan" className='add-only' value="No" /> No &nbsp; (explain):
                </p>
                <p>
                    <textarea id="txtInitialTreatmentPlan" name="txtInitialTreatmentPlan" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>The updated evaluation and treatment plan?</span>
                    <input type="radio" id="rbUpdatedTreatmentPlan_Yes" name="rbUpdatedTreatmentPlan" className='add-only' value="Yes" /> Yes &nbsp;
                    <input type="radio" id="rbUpdatedTreatmentPlan_No" name="rbUpdatedTreatmentPlan" className='add-only' value="No" /> No &nbsp; (explain):
                </p>
                <p>
                    <textarea id="txtUpdatedTreatmentPlan" name="txtUpdatedTreatmentPlan" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Other behavioral health provider name and date last notified:</span>
                    <textarea id="txtBehavioralHealthProviderName" name="txtBehavioralHealthProviderName" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>PCP name and date last notified</span>
                    <textarea id="txtPcpName" name="txtPcpName" className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-100'> <strong>1 None</strong></td>
                        <td className='w-100'> <strong>2 Low</strong></td>
                        <td className='w-100'> <strong>3 Moderate</strong></td>
                        <td className='w-100'> <strong>4 High</strong></td>
                        <td className='w-100'> <strong>5 Extreme</strong></td>
                    </tr>
                    <tr>
                        <td className='w-250'>Suicidal</td>
                        <td className='w-100'>
                            <input type="checkbox" id="rbSuicidal_None" name="rbSuicidal_None" className='add-only' value="Yes" />
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" id="rbSuicidal_Low" name="rbSuicidal_Low" className='add-only' value="Yes" />
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" id="rbSuicidal_Moderate" name="rbSuicidal_Moderate" className='add-only' value="Yes" />
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" id="rbSuicidal_High" name="rbSuicidal_High" className='add-only' value="Yes" />
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" id="rbSuicidal_Extreme" name="rbSuicidal_Extreme" className='add-only' value="Yes" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Homicidal </td>
                        <td className='w-100'>
                            <input type="checkbox" id="rbHomicidal_None" name="rbHomicidal_None" className='add-only' value="Yes" />
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" id="rbHomicidal_Low" name="rbHomicidal_Low" className='add-only' value="Yes" />
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" id="rbHomicidal_Moderate" name="rbHomicidal_Moderate" className='add-only' value="Yes" />
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" id="rbHomicidal_High" name="rbHomicidal_High" className='add-only' value="Yes" />
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" id="rbHomicidal_Extreme" name="rbHomicidal_Extreme" className='add-only' value="Yes" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Assault/violent </td>
                        <td className='w-100'>
                            <input type="checkbox" id="rbAssault_None" name="rbAssault_None" className='add-only' value="Yes" />
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" id="rbAssault_Low" name="rbAssault_Low" className='add-only' value="Yes" />
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" id="rbAssault_Moderate" name="rbAssault_Moderate" className='add-only' value="Yes" />
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" id="rbAssault_High" name="rbAssault_High" className='add-only' value="Yes" />
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" id="rbAssault_Extreme" name="rbAssault" className='add-only' value="Yes" />
                        </td>
                    </tr>
                </table>

                <h3>Medications</h3>
                <p>
                    <span className='eleHeader'>Is member prescribed medications?</span>
                    <input type="radio" id="rbMemberPrescribedMedications_Yes" name="rbMemberPrescribedMedications" className='add-only' value="Yes" /> Yes &nbsp;
                    <input type="radio" id="rbMemberPrescribedMedications_No" name="rbMemberPrescribedMedications" className='add-only' value="No" /> No &nbsp;
                </p>
                <p>
                    <span className='eleHeader'>Prescribing physician(s) name(s):</span>
                    <input type="text" id="txtPrescribingPhysicianName" name="txtPrescribingPhysicianName" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Is member compliant with medications?</span>
                    <input type="radio" id="rbMemberCompliantMedications_Yes" name="rbMemberCompliantMedications" className='add-only' value="Yes" /> Yes &nbsp;
                    <input type="radio" id="rbMemberCompliantMedications_No" name="rbMemberCompliantMedications" className='add-only' value="No" /> No &nbsp;
                </p>
                <p>
                    <span className='eleHeader'>Please list medications and dosages:</span>
                    Medications: <input type="text" id="txtListMedication" name="txtListMedication" placeholder='Medications' className='add-only' />
                    <br />
                    Dosages: <input type="text" id="txtListMedication1" name="txtListMedication1" placeholder='Dosages'  className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Please attach the following to the authorization request:</span>
                    <input type="checkbox" id="cbClinicalAssessment" name="cbClinicalAssessment" className='add-only' value="Yes" /> Clinical assessment
                    <input type="checkbox" id="cbTreatmentPlan" name="cbTreatmentPlan" className='add-only' value="Yes" /> Treatment plan
                    <input type="checkbox" id="cbChoiceProviderForm" name="cbChoiceProviderForm" className='add-only' value="Yes" /> Choice in provider form
                </p>


                <h3>Treatment request (please check services being requested)</h3>
                <p>
                    Treatment start date:
                    <input type="date" id="txtTreatmentStartDate" name="txtTreatmentStartDate" className='add-only' />
                </p>

                <table>
                    <tr>
                        <td className='w-10'>
                            <input type="checkbox" id="cbPsychosocialRehabilitation" name="cbPsychosocialRehabilitation" className='add-only' value="Yes" />
                        </td>
                        <td className='w-740'> <span className='eleHeader'>Community psychiatric support and treatment (CPST):</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            Goal-directed and solution-focused community-based interventions.
                        </td>
                    </tr>
                </table>
                <p>
                    Service code: <input placeholder="Service code" type="text" id="txtServiceCode_1" name="txtServiceCode_1" className='add-only' />
                    Number of units: <input placeholder="Number of units" type="text" id="txtNumberUnits_1" name="txtNumberUnits_1" className='add-only' />
                    per week
                </p>

                <table>
                    <tr>
                        <td className='w-10'>
                            <input type="checkbox" id="cbTherapeuticGroupHome" name="cbTherapeuticGroupHome" className='add-only' value="Yes" />
                        </td>
                        <td className='w-740'>
                            <span className='eleHeader'>Therapeutic group home (TGH):</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            Community-based residential services in a home-like setting.
                        </td>
                    </tr>
                </table>
                <p>
                    Service code: <input placeholder="Service code" type="text" id="txtServiceCode_2" name="txtServiceCode_2" className='add-only' />
                    Number of units: <input placeholder="Number of units" type="text" id="txtNumberUnits_2" name="txtNumberUnits_2" className='add-only' />per week
                </p>

                <table>
                    <tr>
                        <td className='w-10'>
                            <input type="checkbox" id="cbHomeBuilders" name="cbHomeBuilders" className='add-only' value="Yes" />
                        </td>
                        <td className='w-740'>
                            <span className='eleHeader'>
                                Home builders (HB):
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            Provides youth between birth and 18 years old intensive in-home cognitive behavioral therapy through family therapy and parent training.
                            Youth are at risk of out-of-home placement, returning from out-of-home placement, or have serious behavior problems at home and school.
                        </td>
                    </tr>
                </table>
                <p>
                    Service code: <input placeholder="Service code" type="text" id="txtServiceCode_3" name="txtServiceCode_3" className='add-only' />
                    Number of units: <input placeholder="Number of units" type="text" id="txtNumberUnits_3" name="txtNumberUnits_3" className='add-only' /> per week
                </p>

                <table>
                    <tr>
                        <td className='w-10'>
                            <input type="checkbox" id="cbMultiSystemicTherapy" name="cbMultiSystemicTherapy" className='add-only' value="Yes" />
                        </td>
                        <td className='w-740'>
                            <span className='eleHeader'>Multi-systemic therapy (MST):</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            Provides youth between 12 and 17 years old intensive home-, family-, and community-based therapy. Youth are at risk of out-of-home
                            placement or are returning from out-of-home placement.
                        </td>
                    </tr>
                </table>
                <p>
                    Service code: <input placeholder="Service code" type="text" id="txtServiceCode_4" name="txtServiceCode_4" className='add-only' />
                    Number of units: <input placeholder="Number of units" type="text" id="txtNumberUnits_4" name="txtNumberUnits_4" className='add-only' /> per week
                </p>

                <table>
                    <tr>
                        <td className='w-10'>
                            <input type="checkbox" id="cbFamilyFunctionalTherapy" name="cbFamilyFunctionalTherapy" className='add-only' value="Yes" />
                        </td>
                        <td className='w-740'>
                            <span className='eleHeader'>Family functional therapy (FFT):</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            For youth between 10 and 18 years old, targeting behaviours that impact family functioning.
                        </td>
                    </tr>
                </table>
                <p>
                    Service code: <input placeholder="Service code" type="text" id="txtServiceCode_5" name="txtServiceCode_5" className='add-only' />
                    Number of units: <input placeholder="Number of units" type="text" id="txtNumberUnits_5" name="txtNumberUnits_5" className='add-only' /> per week
                </p>


                <h3>Treatment request (continued)</h3>
                <table>
                    <tr>
                        <td className='w-10'>
                            <input type="checkbox" id="cbPsychosocialRehabilitationPsr" name="cbPsychosocialRehabilitationPsr" className='add-only' value="Yes" />
                        </td>
                        <td className='w-740'>
                            <span className='eleHeader'>
                                Psychosocial rehabilitation (PSR):
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            Services to restore a member to the fullest possible extent as an active and productive member of his or her family and community.
                        </td>
                    </tr>
                </table>
                <p>
                    PSR individual in the office number of units per week: <input type="text" id="txtPsrIndividual_1" name="txtPsrIndividual_1" className='add-only' />
                </p>
                <p>
                    PSR individual in the community number of units per week: <input type="text" id="txtPsrIndividual_2" name="txtPsrIndividual_2" className='add-only' />
                </p>
                <p>
                    PSR group in the office number of units per week: <input type="text" id="txtPsrIndividual_3" name="txtPsrIndividual_3" className='add-only' />
                </p>
                <p>
                    PSR group in the community number of units per week: <input type="text" id="txtPsrIndividual_4" name="txtPsrIndividual_4" className='add-only' />
                </p>

                <table>
                    <tr>
                        <td className='w-10'>
                            <input type="checkbox" id="cbCrisisStabilization" name="cbCrisisStabilization" className='add-only' value="Yes" />
                        </td>
                        <td className='w-740'>
                            <span className='eleHeader'>Crisis stabilization:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            Short-term and intensive supportive resources for youth and family; out-of-home option
                            to avoid psychiatric inpatient or institutional treatment. This service is being requested to prevent the member
                            from inpatient or institutional treatment, and the member is currently in crisis. Up to seven days will be
                            authorized initially, and a child cannot receive more than 30 calendar days of this service per year.
                        </td>
                    </tr>
                </table>
                <p>
                    Service code: <input placeholder="Service code" type="text" id="txtServiceCode_6" name="txtServiceCode_6" className='add-only' />
                    Number of units: <input placeholder="Number of units" type="text" id="txtNumberUnits_6" name="txtNumberUnits_6" className='add-only' /> per week
                </p>
                <p>
                    <span className='eleHeader'>Are the requested services part of permanent supportive housing (PSH)?</span>
                    <input type="radio" id="rbPsh_Yes" name="rbPsh" className='add-only' value="Yes" /> Yes &nbsp;
                    <input type="radio" id="rbPsh_No" name="rbPsh" className='add-only' value="No" /> No &nbsp;
                </p>


                <h3>For all initial requests, please indicate below:</h3>
                <p>
                    <span className='eleHeader'>1. Treatment plan:</span>
                    <strong>
                        Please clearly indicate the service (e.g., CPST or PSR) and what interventions (e.g., anger management, social skills, etc.)
                    </strong>
                    will be provided under each service requested. Please specify, for each intervention, the duration and frequency of delivery
                    per week (e.g., 30-minute sessions, twice per week) and the number of weeks needed to complete one cycle of intervention
                    (e.g, social skill training lasts 12 weeks, relaxation training and practice sessions last eight weeks, etc.).
                </p>

                <p>
                    For each problem and goal, fill in the appropriate information below it.
                </p>

                <p>
                    <strong>Problem/goal</strong>
                    <textarea id="txtProblemGoal_1" name="txtProblemGoal_1" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Mental health rehabilitation service</span>
                    <input value="PSR/CPST" type="text" id="txtMentalHealthRehabilitationService_1" name="txtMentalHealthRehabilitationService_1" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Type of intervention</span>
                    <input value="CBT" type="text" id="txtTypeIntervention_1" name="txtTypeIntervention_1" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Duration (minutes) and frequency (sessions per week)</span>
                    <input value="60mins/3x per wk" type="text" id="txtDurationFrequency_1" name="txtDurationFrequency_1" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Length of intervention </span>
                    <span className='small'>(weeks needed tocomplete one cycle)</span>
                    <input type="text" id="txtLengthIntervention_1" name="txtLengthIntervention_1" className='add-only' value="24 weeks" />
                </p>
                <p>
                    <span className='eleHeader'>Who will provide the intervention?</span>
                    <input type="text" id="txtWhoProvideIntervention_1" name="txtWhoProvideIntervention_1" className='add-only' value="MLP/UP" />
                </p>

                <p>
                    <strong>Problem/goal</strong>
                    <textarea id="txtProblemGoal_2" name="txtProblemGoal_2" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Mental health rehabilitation service</span>
                    <input type="text" id="txtMentalHealthRehabilitationService_2" name="txtMentalHealthRehabilitationService_2" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Type of intervention</span>
                    <input type="text" id="txtTypeIntervention_2" name="txtTypeIntervention_2" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Duration (minutes) and frequency (sessions per week)</span>
                    <input type="text" id="txtDurationFrequency_2" name="txtDurationFrequency_2" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Length of intervention </span>
                    <span className='small'>(weeks needed tocomplete one cycle)</span>
                    <input type="text" id="txtLengthIntervention_2" name="txtLengthIntervention_2" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Who will provide the intervention?</span>
                    <input type="text" id="txtWhoProvideIntervention_2" name="txtWhoProvideIntervention_2" className='add-only' />
                </p>

                <p>
                    <strong>Problem/goal</strong>
                    <textarea id="txtProblemGoal_3" name="txtProblemGoal_3" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Mental health rehabilitation service</span>
                    <input type="text" id="txtMentalHealthRehabilitationService_3" name="txtMentalHealthRehabilitationService_3" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Type of intervention</span>
                    <input type="text" id="txtTypeIntervention_3" name="txtTypeIntervention_3" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Duration (minutes) and frequency (sessions per week)</span>
                    <input type="text" id="txtDurationFrequency_3" name="txtDurationFrequency_3" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Length of intervention </span>
                    <span className='small'>(weeks needed tocomplete one cycle)</span>
                    <input type="text" id="txtLengthIntervention_3" name="txtLengthIntervention_3" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Who will provide the intervention?</span>
                    <input type="text" id="txtWhoProvideIntervention_3" name="txtWhoProvideIntervention_3" className='add-only' />
                </p>

                <p>
                    <strong>Problem/goal</strong>
                    <textarea id="txtProblemGoal_4" name="txtProblemGoal_4" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Mental health rehabilitation service</span>
                    <input type="text" id="txtMentalHealthRehabilitationService_4" name="txtMentalHealthRehabilitationService_4" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Type of intervention</span>
                    <input type="text" id="txtTypeIntervention_4" name="txtTypeIntervention_4" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Duration (minutes) and frequency (sessions per week)</span>
                    <input type="text" id="txtDurationFrequency_4" name="txtDurationFrequency_4" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Length of intervention </span>
                    <span className='small'>(weeks needed tocomplete one cycle)</span>
                    <input type="text" id="txtLengthIntervention_4" name="txtLengthIntervention_4" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Who will provide the intervention?</span>
                    <input type="text" id="txtWhoProvideIntervention_4" name="txtWhoProvideIntervention_4" className='add-only' />
                </p>

                <p>
                    <strong>Problem/goal</strong>
                    <textarea id="txtProblemGoal_5" name="txtProblemGoal_5" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Mental health rehabilitation service</span>
                    <input type="text" id="txtMentalHealthRehabilitationService_5" name="txtMentalHealthRehabilitationService_5" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Type of intervention</span>
                    <input type="text" id="txtTypeIntervention_5" name="txtTypeIntervention_5" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Duration (minutes) and frequency (sessions per week)</span>
                    <input type="text" id="txtDurationFrequency_5" name="txtDurationFrequency_5" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Length of intervention </span>
                    <span className='small'>(weeks needed tocomplete one cycle)</span>
                    <input type="text" id="txtLengthIntervention_5" name="txtLengthIntervention_5" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Who will provide the intervention?</span>
                    <input type="text" id="txtWhoProvideIntervention_5" name="txtWhoProvideIntervention_5" className='add-only' />
                </p>

                <p>
                    <span className='eleHeader'>1a. If you are requesting to provide both CPST and PSR, please explain the need for both services and how the services will differ in content:</span>
                    <textarea id="txtCpstDifferPsr" name="txtCpstDifferPsr" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>1b. If the member has not had any prior behavioral health services, please provide reasons why clinic-based services are not an option:</span>
                    <textarea id="txtWhyClinicBasedServicesNotOption" name="txtWhyClinicBasedServicesNotOption" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>2. The member is unable to be managed at a less intensive level of care safely within the last week.</span>
                    <input type="radio" id="rbMemberUnableToManaged_Yes" name="rbMemberUnableToManaged" className='add-only' value="Yes" /> Yes &nbsp;
                    <input type="radio" id="rbMemberUnableToManaged_No" name="rbMemberUnableToManaged" className='add-only' value="No" /> No &nbsp;
                </p>
                <p>
                    <span className='eleHeader'>3. Is the member currently in short-term respite or any other mental health/substance use disorder service(s)?</span>
                    <input type="radio" id="rbMemberCurrentlyShortTermRespite_Yes" name="rbMemberCurrentlyShortTermRespite" className='add-only' value="Yes" /> Yes &nbsp;
                    <input type="radio" id="rbMemberCurrentlyShortTermRespite_No" name="rbMemberCurrentlyShortTermRespite" className='add-only' value="No" /> No &nbsp;
                </p>
                <p>
                    If yes, explain:
                    <textarea id="txtMemberCurrentlyShortTermRespiteIfYes" name="txtMemberCurrentlyShortTermRespiteIfYes" className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>4. The member has displayed any of the following within the last week:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMemberDisplayedAnyFollowing_1" name="cbMemberDisplayedAnyFollowing_1" className='add-only' value="Yes" />Angry outbursts/aggression that is unmanageable</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMemberDisplayedAnyFollowing_2" name="cbMemberDisplayedAnyFollowing_2" className='add-only' value="Yes" />Arrest/confirmed illegal activity</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMemberDisplayedAnyFollowing_3" name="cbMemberDisplayedAnyFollowing_3" className='add-only' value="Yes" />Cruelty to animals</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMemberDisplayedAnyFollowing_4" name="cbMemberDisplayedAnyFollowing_4" className='add-only' value="Yes" />Daredevil and/or impulsive behaviors</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMemberDisplayedAnyFollowing_5" name="cbMemberDisplayedAnyFollowing_5" className='add-only' value="Yes" />Delusions/hallucinations</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMemberDisplayedAnyFollowing_6" name="cbMemberDisplayedAnyFollowing_6" className='add-only' value="Yes" />Destruction of property</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMemberDisplayedAnyFollowing_7" name="cbMemberDisplayedAnyFollowing_7" className='add-only' value="Yes" />Disorganized thoughts, speech, or behavior</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMemberDisplayedAnyFollowing_8" name="cbMemberDisplayedAnyFollowing_8" className='add-only' value="Yes" />Encopresis and feces smearing</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMemberDisplayedAnyFollowing_9" name="cbMemberDisplayedAnyFollowing_9" className='add-only' value="Yes" />Fire setting</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMemberDisplayedAnyFollowing_10" name="cbMemberDisplayedAnyFollowing_10" className='add-only' value="Yes" />Hypomanic or hypermanic symptoms increased and/or psychomotor agitation</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMemberDisplayedAnyFollowing_11" name="cbMemberDisplayedAnyFollowing_11" className='add-only' value="No" /> No &nbsp;n-suicidal self-injury</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMemberDisplayedAnyFollowing_12" name="cbMemberDisplayedAnyFollowing_12" className='add-only' value="Yes" />Obsessions or compulsions</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMemberDisplayedAnyFollowing_13" name="cbMemberDisplayedAnyFollowing_13" className='add-only' value="Yes" />Persistent violation of court orders</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMemberDisplayedAnyFollowing_14" name="cbMemberDisplayedAnyFollowing_14" className='add-only' value="Yes" />Repeated running away for more than 24 hours</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMemberDisplayedAnyFollowing_15" name="cbMemberDisplayedAnyFollowing_15" className='add-only' value="Yes" />Sexually inappropriate/aggressive/abusive/threatening</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMemberDisplayedAnyFollowing_16" name="cbMemberDisplayedAnyFollowing_16" className='add-only' value="Yes" />Suicidal ideations</td>
                    </tr>
                </table>

                <p>
                    <span className='eleHeader'>5. Have the behaviors been persistent for at least six months?</span>
                    <input type="radio" id="rbLeastSixMonths_Yes" name="rbLeastSixMonth" className='add-only' value="Yes" /> Yes &nbsp;
                    <input type="radio" id="rbLeastSixMonths_No" name="rbLeastSixMonth" className='add-only' value="No" /> No &nbsp;
                </p>
                <p>
                    <span className='eleHeader'>6. Are the behaviors expected to continue longer than one year without treatment?</span>
                    <input type="radio" id="rbOneYearWithoutTreatment_Yes" name="rbOneYearWithoutTreatment" className='add-only' value="Yes" /> Yes &nbsp;
                    <input type="radio" id="rbOneYearWithoutTreatment_No" name="rbOneYearWithoutTreatment" className='add-only' value="No" /> No &nbsp;
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>
                                7. The member has had unsuccessful treatment history (lack of improvement) in any of the following within the last month (check all that apply):
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbUnsuccessfulTreatmentHistory_1" name="cbUnsuccessfulTreatmentHistory_1" className='add-only' value="Yes" />CSoC</td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbUnsuccessfulTreatmentHistory_3" name="cbUnsuccessfulTreatmentHistory_3" className='add-only' value="Yes" />Outpatient therapy services</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbUnsuccessfulTreatmentHistory_4" name="cbUnsuccessfulTreatmentHistory_4" className='add-only' value="Yes" />Psychiatric inpatient admission(s)</td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbUnsuccessfulTreatmentHistory_6" name="cbUnsuccessfulTreatmentHistory_6" className='add-only' value="Yes" />Residential treatment</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbUnsuccessfulTreatmentHistory_7" name="cbUnsuccessfulTreatmentHistory_7" className='add-only' value="Yes" />Substance use disorder treatment</td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbUnsuccessfulTreatmentHistory_8" name="cbUnsuccessfulTreatmentHistory_8" className='add-only' value="Yes" />TGH</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbUnsuccessfulTreatmentHistory_9" name="cbUnsuccessfulTreatmentHistory_9" className='add-only' value="Yes" />Treatment foster care</td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbUnsuccessfulTreatmentHistory_2" name="cbUnsuccessfulTreatmentHistory_2" className='add-only' value="Yes" />Mental health rehabilitation services (CPST, PSR, HB, FFT, MST)</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>8. The member’s support system is any of the following within the last month (check all that apply):</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMemberSupportSystem_1" name="cbMemberSupportSystem_1" className='add-only' value="Yes" />Abusive</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMemberSupportSystem_3" name="cbMemberSupportSystem_3" className='add-only' value="Yes" />Intentionally sabotages treatments</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMemberSupportSystem_4" name="cbMemberSupportSystem_4" className='add-only' value="Yes" />Involved in treatment and treatment planning</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMemberSupportSystem_5" name="cbMemberSupportSystem_5" className='add-only' value="Yes" />Unable to ensure safety</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMemberSupportSystem_6" name="cbMemberSupportSystem_6" className='add-only' value="Yes" />Unable to manage the intensity of the member’s symptoms without a structured program</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMemberSupportSystem_7" name="cbMemberSupportSystem_7" className='add-only' value="Yes" />Unavailable</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMemberSupportSystem_2" name="cbMemberSupportSystem_2" className='add-only' value="Yes" />High risk environment (please specify what makes it high risk):</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="text" id="txtMemberSupportSystem_21" name="txtMemberSupportSystem_21" className='add-only' />
                            <input type="text" id="txtMemberSupportSystem_22" name="txtMemberSupportSystem_22" className='add-only' />
                            </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>9. The member’s living environment (please check one):</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMemberLivingEnvironment_1" name="cbMemberLivingEnvironment_1" className='add-only' value="Yes" />Member is living in a safe environment</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMemberLivingEnvironment_2" name="cbMemberLivingEnvironment_2" className='add-only' value="Yes" />Member is emancipated from family and lacks independent living skills</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMemberLivingEnvironment_3" name="cbMemberLivingEnvironment_3" className='add-only' value="Yes" />Member has demonstrated intolerance for family environment or adult authority and needs out of home placement (child/adolescent)</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>10. The member has severe impairment in the below (check all that apply):</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbImpairmentInBelow_1" name="cbImpairmentInBelow_1" className='add-only' value="Yes" />Activities of daily living (ADLs)</td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbImpairmentInBelow_2" name="cbImpairmentInBelow_2" className='add-only' value="Yes" />Community living</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbImpairmentInBelow_3" name="cbImpairmentInBelow_3" className='add-only' value="Yes" />Social relationships</td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbImpairmentInBelow_4" name="cbImpairmentInBelow_4" className='add-only' value="Yes" />Family relationships</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbImpairmentInBelow_5" name="cbImpairmentInBelow_5" className='add-only' value="Yes" />School performance</td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                </table>


                <h3>For all continued stay requests, please indicate the below:</h3>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>1. Within the last month the member has experienced and/or displayed the following (check all that apply):</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbDisplayedFollowing_2" name="cbDisplayedFollowing_2" className='add-only' value="Yes" />Depressed mood with associated symptoms</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbDisplayedFollowing_5" name="cbDisplayedFollowing_5" className='add-only' value="Yes" />Has had an after-hours crisis</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbDisplayedFollowing_9" name="cbDisplayedFollowing_9" className='add-only' value="Yes" />Hypomanic symptoms</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbDisplayedFollowing_10" name="cbDisplayedFollowing_10" className='add-only' value="Yes" />Is neglecting ADLs and/or needs monitoring for ADLs</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbDisplayedFollowing_11" name="cbDisplayedFollowing_11" className='add-only' value="Yes" />Obsessions/compulsions</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbDisplayedFollowing_12" name="cbDisplayedFollowing_12" className='add-only' value="Yes" />Psychiatric medication noncompliance</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbDisplayedFollowing_13" name="cbDisplayedFollowing_13" className='add-only' value="Yes" />Psychosis</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbDisplayedFollowing_14" name="cbDisplayedFollowing_14" className='add-only' value="Yes" />Post-traumatic stress disorder or history of trauma</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbDisplayedFollowing_7" name="cbDisplayedFollowing_7" className='add-only' value="Yes" />Has ongoing isolation and/or inappropriate social behaviors</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbDisplayedFollowing_4" name="cbDisplayedFollowing_4" className='add-only' value="Yes" />Has been arrested</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbDisplayedFollowing_8" name="cbDisplayedFollowing_8" className='add-only' value="Yes" />Has school problems resulting in suspensions or expulsion</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbDisplayedFollowing_15" name="cbDisplayedFollowing_15" className='add-only' value="Yes" />Suicidal and/or homicidal ideations (with or without intent)</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbDisplayedFollowing_3" name="cbDisplayedFollowing_3" className='add-only' value="Yes" />Disruptive behaviors (check all that apply):</td>
                    </tr>

                    <tr>
                        <td className='w-20'>&nbsp;</td>
                        <td className='w-730'>
                            <input type="checkbox" id="cbDisplayedFollowing_3a" name="cbDisplayedFollowing_3a" className='add-only' value="Yes" />Cruelty to animals</td>
                    </tr>
                    <tr>
                        <td className='w-20'>&nbsp;</td>
                        <td className='w-730'>
                            <input type="checkbox" id="cbDisplayedFollowing_3b" name="cbDisplayedFollowing_3b" className='add-only' value="Yes" />Destruction of property</td>
                    </tr>
                    <tr>
                        <td className='w-20'>&nbsp;</td>
                        <td className='w-730'>
                            <input type="checkbox" id="cbDisplayedFollowing_3c" name="cbDisplayedFollowing_3c" className='add-only' value="Yes" />Distractibility</td>
                    </tr>
                    <tr>
                        <td className='w-20'>&nbsp;</td>
                        <td className='w-730'>
                            <input type="checkbox" id="cbDisplayedFollowing_3d" name="cbDisplayedFollowing_3d" className='add-only' value="Yes" />Serious rule violations</td>
                    </tr>
                    <tr>
                        <td className='w-20'>&nbsp;</td>
                        <td className='w-730'>
                            <input type="checkbox" id="cbDisplayedFollowing_3e" name="cbDisplayedFollowing_3e" className='add-only' value="Yes" />Stalking</td>
                    </tr>
                    <tr>
                        <td className='w-20'>&nbsp;</td>
                        <td className='w-730'>
                            <input type="checkbox" id="cbDisplayedFollowing_3f" name="cbDisplayedFollowing_3f" className='add-only' value="Yes" />Theft</td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbDisplayedFollowing_6" name="cbDisplayedFollowing_6" className='add-only' value="Yes" />Has interpersonal conflicts (check all that apply):</td>
                    </tr>
                    <tr>
                        <td className='w-20'>&nbsp;</td>
                        <td className='w-730'>
                            <input type="checkbox" id="cbDisplayedFollowing_6a" name="cbDisplayedFollowing_6a" className='add-only' value="Yes" />Anger outburst</td>
                    </tr>
                    <tr>
                        <td className='w-20'>&nbsp;</td>
                        <td className='w-730'>
                            <input type="checkbox" id="cbDisplayedFollowing_6b" name="cbDisplayedFollowing_6b" className='add-only' value="Yes" />Hostile/intimidating</td>
                    </tr>
                    <tr>
                        <td className='w-20'>&nbsp;</td>
                        <td className='w-730'>
                            <input type="checkbox" id="cbDisplayedFollowing_6c" name="cbDisplayedFollowing_6c" className='add-only' value="Yes" />Manipulative</td>
                    </tr>
                    <tr>
                        <td className='w-20'>&nbsp;</td>
                        <td className='w-730'>
                            <input type="checkbox" id="cbDisplayedFollowing_6d" name="cbDisplayedFollowing_6d" className='add-only' value="Yes" />Poor boundaries</td>
                    </tr>
                </table>


                <p>
                    <span className='eleHeader'>2. The member is receiving the following services:</span>
                    <strong>Treatment plan: Please clearly indicate the service (e.g., CPST or PSR) and what interventions (e.g., anger management, social skills, etc.) will be provided under each service requested.</strong>
                    Please specify, for each intervention, the duration and frequency of delivery per week (e.g., 30-minute sessions, twice per week) and the number of weeks needed to complete one cycle of intervention
                    (e.g., social skill training lasts 12 weeks, relaxation training and practice sessions last 8 weeks, etc.).
                </p>

                <p>
                    For each problem and goal, fill in the appropriate information below it.
                </p>

                <p>
                    <strong>Problem/goal</strong>
                    <textarea id="txtProblemGoal_6" name="txtProblemGoal_6" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Mental health rehabilitation service</span>
                    <input defaultValue={'PSR/CPST'}  type="text" id="txtMentalHealthRehabilitationService_6" name="txtMentalHealthRehabilitationService_6" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Type of intervention</span>
                    <input defaultValue={'CBT'}  type="text" id="txtTypeIntervention_6" name="txtTypeIntervention_6" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Duration (minutes) and frequency (sessions per week)</span>
                    <input defaultValue={'60mins/3x per wk'}  type="text" id="txtDurationFrequency_6" name="txtDurationFrequency_6" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Length of intervention </span>
                    <span className='small'>(weeks needed tocomplete one cycle)</span>
                    <input defaultValue={'24 weeks'}  type="text" id="txtLengthIntervention_6" name="txtLengthIntervention_6" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Who will provide the intervention?</span>
                    <input type="text" defaultValue={'MLP/UP'} id="txtWhoProvideIntervention_6" name="txtWhoProvideIntervention_6" className='add-only' />
                </p>

                <p>
                    <strong>Problem/goal</strong>
                    <textarea id="txtProblemGoal_7" name="txtProblemGoal_7" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Mental health rehabilitation service</span>
                    <input type="text" id="txtMentalHealthRehabilitationService_7" name="txtMentalHealthRehabilitationService_7" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Type of intervention</span>
                    <input type="text" id="txtTypeIntervention_7" name="txtTypeIntervention_7" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Duration (minutes) and frequency (sessions per week)</span>
                    <input type="text" id="txtDurationFrequency_7" name="txtDurationFrequency_7" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Length of intervention </span>
                    <span className='small'>(weeks needed tocomplete one cycle)</span>
                    <input type="text" id="txtLengthIntervention_7" name="txtLengthIntervention_7" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Who will provide the intervention?</span>
                    <input type="text" id="txtWhoProvideIntervention_7" name="txtWhoProvideIntervention_7" className='add-only' />
                </p>

                <p>
                    <strong>Problem/goal</strong>
                    <textarea id="txtProblemGoal_8" name="txtProblemGoal_8" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Mental health rehabilitation service</span>
                    <input type="text" id="txtMentalHealthRehabilitationService_8" name="txtMentalHealthRehabilitationService_8" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Type of intervention</span>
                    <input type="text" id="txtTypeIntervention_8" name="txtTypeIntervention_8" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Duration (minutes) and frequency (sessions per week)</span>
                    <input type="text" id="txtDurationFrequency_8" name="txtDurationFrequency_8" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Length of intervention </span>
                    <span className='small'>(weeks needed tocomplete one cycle)</span>
                    <input type="text" id="txtLengthIntervention_8" name="txtLengthIntervention_8" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Who will provide the intervention?</span>
                    <input type="text" id="txtWhoProvideIntervention_8" name="txtWhoProvideIntervention_8" className='add-only' />
                </p>

                <p>
                    <strong>Problem/goal</strong>
                    <textarea id="txtProblemGoal_9" name="txtProblemGoal_9" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Mental health rehabilitation service</span>
                    <input type="text" id="txtMentalHealthRehabilitationService_9" name="txtMentalHealthRehabilitationService_9" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Type of intervention</span>
                    <input type="text" id="txtTypeIntervention_9" name="txtTypeIntervention_9" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Duration (minutes) and frequency (sessions per week)</span>
                    <input type="text" id="txtDurationFrequency_9" name="txtDurationFrequency_9" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Length of intervention </span>
                    <span className='small'>(weeks needed tocomplete one cycle)</span>
                    <input type="text" id="txtLengthIntervention_9" name="txtLengthIntervention_9" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Who will provide the intervention?</span>
                    <input type="text" id="txtWhoProvideIntervention_9" name="txtWhoProvideIntervention_9" className='add-only' />
                </p>

                <p>
                    <strong>Problem/goal</strong>
                    <textarea id="txtProblemGoal_10" name="txtProblemGoal_10" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Mental health rehabilitation service</span>
                    <input type="text" id="txtMentalHealthRehabilitationService_10" name="txtMentalHealthRehabilitationService_10" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Type of intervention</span>
                    <input type="text" id="txtTypeIntervention_10" name="txtTypeIntervention_10" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Duration (minutes) and frequency (sessions per week)</span>
                    <input type="text" id="txtDurationFrequency_10" name="txtDurationFrequency_10" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Length of intervention </span>
                    <span className='small'>(weeks needed tocomplete one cycle)</span>
                    <input type="text" id="txtLengthIntervention_10" name="txtLengthIntervention_10" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Who will provide the intervention?</span>
                    <input type="text" id="txtWhoProvideIntervention_10" name="txtWhoProvideIntervention_10" className='add-only' />
                </p>

                <p>
                    <span className='eleHeader'>2a. If you are requesting to provide both CPST and PSR please explain the need for both services and how the services will differ in content:</span>
                    <input id="txtCpstPsrDifferExplain1" name="txtCpstPsrDifferExplain1" type="text" className='add-only' />
                    <br />
                    <input id="txtCpstPsrDifferExplain2" name="txtCpstPsrDifferExplain2" type="text" className='add-only' />
                </p>

                <p>
                    <span className='eleHeader'>2b. Provide reasons why clinic-based services are not an option for this member at this time:</span>
                    <input id="txtReasonWhyClinicBasedServices1" name="txtReasonWhyClinicBasedServices1" type="text" className='add-only' />
                    <br />
                    <input id="txtReasonWhyClinicBasedServices2" name="txtReasonWhyClinicBasedServices2" type="text" className='add-only' />
                </p>

                <p>
                    <span className='eleHeader'>3. Additional clinical information to support the medical necessity of the requested services:</span>
                    <textarea id="txtAdditionalClinicalInformation" name="txtAdditionalClinicalInformation" className='add-only'></textarea>
                </p>

            </div>
        </form>

    )
}   